const routes = {
  '/dashboard': ['general', 'space'],
  '/dashboard-v2': ['general', 'space'],
  '/partidos': ['matches', 'competition'],
  '/actaPartido': ['matches', 'competition', '/partidos'],
  '/informePartido': ['matches', 'competition', '/partidos'],
  '/clasificacion': ['standings', 'competition'],
  '/clubes': ['clubs', 'competition'],
  '/rankingJugadores': ['players', 'competition'],
  '/jugadoresSimilares': ['players', 'competition', '/rankingJugadores'],
  '/compararJugadores': ['players', 'competition', '/rankingJugadores'],
  '/jugador': ['players', 'competition', '/rankingJugadores'],
  '/estadisticas': ['players', 'competition', '/rankingJugadores'],
  '/rankingEquipos': ['teamRanking', 'competition'],
  '/estadisticasEquipos': ['teams', 'competition'],
  '/estadisticasArbitros': ['referees', 'competition'],
  '/scouting': ['scouting', 'technical'],
  '/analisisIndividual': ['individual', 'technical'],
  '/herramientas': ['utilities', 'technical'],
  '/agente': ['assistant', 'technical'],
  '/planificacion': ['planning', 'technical'],
  '/pizarras': ['tacticalBoards', 'technical'],
  '/live-tag': ['tagging', 'technical'],
  '/cliente-windows': ['windows', 'technical'],
  '/perfil': ['account', 'account'],
  '/tutoriales': ['tutorials', 'account'],
  '/administrar-equipos': ['manageTeams', 'account'],
  '/licencias': ['licenses', 'account'],
  '/mis-licencias': ['myLicenses', 'account'],
  '/admin/analytics': ['adminAnalytics', 'admin'],
  '/admin/usuarios': ['adminUsers', 'admin'],
  '/admin/licencias': ['adminLicenses', 'admin'],
  '/admin/promo-codes': ['promoCodes', 'admin'],
  '/admin/versiones': ['versions', 'admin'],
  '/admin/feature-flags': ['featureFlags', 'admin'],
};

export function getWorkspaceRoute(pathname) {
  const path = pathname.replace(/\/+$/, '') || '/';
  let base = path;
  if (/^\/estadisticasArbitros\/[^/]+$/.test(path)) base = '/estadisticasArbitros';
  if (/^\/analisisIndividual\/microconcepto\/[^/]+$/.test(path)) base = '/analisisIndividual';
  if (/^\/live-tag\/session\/[^/]+(?:\/video)?$/.test(path)) base = '/live-tag';
  if (/^\/invitaciones\/[^/]+$/.test(path)) {
    return { label: 'invitation', group: 'account', activePath: '/administrar-equipos' };
  }
  const route = routes[base];
  return route ? { label: route[0], group: route[1], activePath: route[2] || base } : null;
}
